<template>
  <v-layout wrap row align-start>
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="card--flex-toolbar">
          <v-toolbar flat>
            <v-btn icon @click="$router.back()">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="grey--text"
              >Detalles del Pedido #{{
                pedido ? $_str_pad_left(pedido.id) : ""
              }}</v-toolbar-title
            >
            <v-spacer />
          </v-toolbar>
        </v-card>
      </v-flex>
      <v-flex grow pa-1 xs12 md6>
        <v-card v-if="pedido">
          <v-img
            v-if="pedido.anonimo === false"
            :src="direccion.imagen_url"
            height="300px"
          />
          <template v-else>
            <v-img
              :src="
                pedido.anonimo_detalles.imagen_url
                  ? pedido.anonimo_detalles.imagen_url
                  : pedido.anonimo_detalles.imagen_path
              "
              height="300px"
            />
          </template>
          <v-list two-line subheader>
            <v-subheader>Pedido</v-subheader>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> mdi-pound </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>FOLIO</v-list-item-title>
                <v-list-item-subtitle>{{
                  $_str_pad_left(pedidoId)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> mdi-cash-register </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Total</v-list-item-title>
                <v-list-item-subtitle>{{
                  $_currency(pedido.total)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> mdi-comment-text </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Comentarios en el pedido:</v-list-item-title>
                <v-list-item-subtitle>{{
                  pedido.comentarios || "Sin comentarios"
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> mdi-credit-card-wireless </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  >Requiere terminal bancaria:</v-list-item-title
                >
                <v-list-item-subtitle>{{
                  pedido.requiere_terminal ? "Si" : "No"
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item ripple @click="dialog_change_status = true">
              <v-list-item-action>
                <v-icon color="indigo"> mdi-list-status </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Estatus</v-list-item-title>
                <v-list-item-subtitle>{{
                  estatus.nombre
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="pedido.delivery_queue"
              ripple
              @click="dialog_see_delivery_log = true"
            >
              <v-list-item-action>
                <v-icon color="indigo"> mdi-menu-open </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Elección de repartidor</v-list-item-title>
                <v-list-item-subtitle>Seguimiento</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="grey lighten-1"> mdi-plus-circle </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item ripple @click="dialog_log_pedido = true">
              <v-list-item-action>
                <v-icon color="indigo"> mdi-timeline </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Historial de estatus</v-list-item-title>
                <v-list-item-subtitle>{{
                  estatus.nombre
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="grey lighten-1"> ballot </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="!pedido.anonimo">
              <v-list-item-action>
                <v-icon color="indigo"> card_giftcard </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Recompensa:</v-list-item-title>
                <v-list-item-subtitle>{{
                  pedido.recompensa_aplicada ? "Aplicada" : "Pendiente"
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset />
            <v-subheader>Detalles de envío</v-subheader>
            <v-list-item
              ripple
              @click="
                pedido.anonimo
                  ? (dialog_change_direccion = true)
                  : noPuedeEditarDireccion()
              "
            >
              <v-list-item-action>
                <v-icon color="indigo"> location_on </v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Dirección de entrega</v-list-item-title>
                <v-list-item-subtitle>{{
                  direccion.direccion
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="pedido.anonimo">
                <v-icon color="grey lighten-1"> edit </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo">
                  mdi-map-marker-question-outline
                </v-icon>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>Condiciones de entrega:</v-list-item-title>
                <v-list-item-subtitle>{{
                  direccion.observaciones
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex grow pa-1 xs12 md6>
        <v-card style="margin-top: 10px" v-if="pedido && pedido.aclaracion">
          <v-card-title>Aclaracion de Saldo</v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea
                    v-model="pedido.aclaracion.comentario"
                    :error-messages="error_comentario"
                    :disabled="!!pedido.aclaracion.user_id"
                    label="Observaciones"
                    placeholder="Agregue una observacion de la cancelacion realizada"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions v-if="!pedido.aclaracion.user_id">
            <v-spacer />
            <v-btn
              color="blue darken-1"
              class="white--text"
              :loading="loadingAclaracion"
              :disabled="loadingAclaracion"
              @click="agregarAclaracion"
            >
              Agregar Aclaracion
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card style="margin-top: 10px">
          <v-card-title>Productos del pedido</v-card-title>
          <v-data-table
            v-if="pedido"
            :headers="tieneModificadores ? headersModificadores : headers"
            :items="pedido_detalles"
            :show-expand="tieneModificadores"
          >
            <template v-slot:item.cantidad="{ item }">
              {{ item.cantidad }}
            </template>
            <template v-slot:item.nombre="{ item }">
              {{ item.producto.nombre }}
            </template>

            <template v-slot:item.importeModificadores="{ item }">
              {{ $_currency(item.importe - item.importe_sin_modificador) }}
            </template>
            <template v-slot:item.precio="{ item }">
              {{ $_currency(item.precio) }}
            </template>
            <template v-slot:item.importe="{ item }">
              {{ $_currency(item.importe) }}
            </template>
            <template v-slot:body.append>
              <tr v-for="envio in pedido.envios" :key="`envios-${envio.id}`">
                <td v-show="tieneModificadores" />
                <td v-show="tieneModificadores" />
                <td colspan="3" style="text-align: right">Costo de Envio</td>
                <td style="text-align: right">
                  {{ $_currency(envio.monto) }}
                </td>
              </tr>
              <tr>
                <td v-show="tieneModificadores" />
                <td v-show="tieneModificadores" />
                <td colspan="3" style="text-align: right">
                  <strong>Total</strong>
                </td>
                <td style="text-align: right">
                  <strong>{{ pedido.total | currency }}</strong>
                </td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: unset">
                <p style="text-align: center; padding-top: 15px">
                  Modificador de: {{ item.producto.nombre }}
                </p>
                <v-simple-table
                  v-if="item.modificador_detalles"
                  style="background-color: lightgray"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Modificador</th>
                        <th>Cantidad</th>
                        <th>Nombre</th>
                        <th>Precio</th>
                        <th>Importe</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="modeDetalles in item.modificador_detalles"
                        :key="modeDetalles + '_detalles'"
                      >
                        <td>
                          {{
                            item.producto.modificadores.find(
                              (element) =>
                                element.id == modeDetalles.modificador_id
                            ).nombre
                          }}
                        </td>
                        <td>
                          {{ modeDetalles.pivot.cantidad }}
                        </td>
                        <td>{{ modeDetalles.nombre }}</td>
                        <td>{{ $_currency(modeDetalles.pivot.precio) }}</td>
                        <td>{{ $_currency(modeDetalles.pivot.importe) }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td />
                        <td colspan="3" style="text-align: right">
                          <strong>Subtotal modificadores</strong>
                        </td>
                        <td>
                          <strong>
                            {{
                              $_currency(
                                item.importe - item.importe_sin_modificador
                              )
                            }}</strong
                          >
                        </td>
                      </tr>
                    </tfoot>
                  </template>
                </v-simple-table>
                <p v-else>Producto sin modificadores</p>
                <!-- </v-card> -->
              </td>
            </template>
          </v-data-table>
        </v-card>
        <v-card style="margin-top: 10px">
          <v-card-title>Pagos</v-card-title>
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">Forma de pago</th>
                <th class="text-left">Folio autorización</th>
                <th class="text-right">Monto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pago in pagosPedido" :key="pago.id + '_pagos'">
                <td>{{ pago.forma_pago | capitalize }}</td>
                <td>{{ pago.folio | uppercase }}</td>
                <td align="right">
                  {{ $_currency(pago.monto) }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td style="text-align: right">
                  <strong>Total</strong>
                </td>
                <td style="text-align: right">
                  <strong>{{ $_currency(0) }}</strong>
                </td>
              </tr>
            </tfoot>
          </v-simple-table>
        </v-card>
        <v-card style="margin-top: 10px">
          <v-card-title>Usuario</v-card-title>
          <v-list two-line v-if="pedido">
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> person </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Nombre</v-list-item-title>
                <v-list-item-subtitle>
                  {{
                    pedido.anonimo
                      ? anonimo.contacto
                      : cliente.nombre +
                        " " +
                        cliente.apellido_paterno +
                        " " +
                        cliente.apellido_materno
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> phone </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Teléfono</v-list-item-title>
                <v-list-item-subtitle>
                  {{ pedido.anonimo ? anonimo.telefono : cliente.telefono }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="indigo"> mail </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cuenta</v-list-item-title>
                <v-list-item-subtitle>
                  {{ pedido.anonimo ? "Usuario anónimo" : cliente.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog_change_status" max-width="600px">
      <form-change-status
        v-if="dialog_change_status"
        :pedido-id="pedido.id"
        :estatus-actual="estatus.id"
        @form:close="dialog_change_status = false"
        @form:save="estatusCambiado"
      />
    </v-dialog>

    <v-dialog
      v-model="dialog_see_delivery_log"
      v-if="pedido && pedido.delivery_queue"
      max-width="1300px"
    >
      <v-tabs v-model="tab_log_pedido" background-color="primary" dark>
        <v-tabs-slider color="black"></v-tabs-slider>
        <v-tab href="#tab-1">Distancia de vendedores </v-tab>
        <v-tab href="#tab-2">Mapa del pedido</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab_log_pedido">
        <v-tab-item key="1" value="tab-1">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Asignación de repartidor al pedido
                {{ $_str_pad_left(pedido.id) }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Vendedor</th>
                        <th class="text-left">Distancia (metros)</th>
                        <th class="text-left">Notificación</th>
                        <th class="text-left">Hora de notificación</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="log in logs"
                        :key="log.id"
                        :style="
                          log.id == repartidor.email
                            ? 'background-color: green; color : white'
                            : ''
                        "
                      >
                        <td xs12 sm6>
                          {{ log.id }}
                        </td>
                        <td>
                          {{ numberWithCommas(log.distance) }}
                        </td>
                        <template>
                          <td>
                            {{ log.status }}
                          </td>
                          <td>
                            {{ log.queue ? log.queue.sent_at : "N/A" }}
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="gray darken-1"
                @click="dialog_see_delivery_log = false"
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <v-tab-item key="2" value="tab-2">
          <v-flex xs12>
            <GmapMap
              :center="{
                lat: direccion_mapa.latitude,
                lng: direccion_mapa.longitude,
              }"
              :zoom="11"
              style="width: 100%; height: 500px"
            >
              <gmap-info-window
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen = false"
              >
              </gmap-info-window>

              <gmap-marker
                :position="{
                  lat: direccion_mapa.latitude,
                  lng: direccion_mapa.longitude,
                }"
                :clickable="true"
                icon="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
              />
              <gmap-cluster>
                <gmap-marker
                  v-for="(vendedor, index) in pedido.delivery_queue.log"
                  :key="index"
                  :position="{
                    lat: vendedor.position.latitude,
                    lng: vendedor.position.longitude,
                  }"
                  :clickable="true"
                  icon="http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                  @click="toggleInfoWindow(vendedor, index)"
                >
                </gmap-marker>
              </gmap-cluster>
            </GmapMap>
          </v-flex>
          <v-card>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="gray darken-1"
                @click="dialog_see_delivery_log = false"
              >
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-dialog>

    <v-dialog v-model="dialog_change_direccion" max-width="600px">
      <form-direccion-anonimo
        v-if="dialog_change_direccion"
        :direccion="pedido.anonimo_detalles"
        :url-action="'/api/pedidos/cambiar-direccion-anonimo/' + pedido.id"
        @form:close="dialog_change_direccion = false"
        @form:save="
          cargarPedido();
          dialog_change_direccion = false;
        "
      />
    </v-dialog>

    <v-dialog v-model="dialog_log_pedido" max-width="900px">
      <log-pedido
        v-if="dialog_log_pedido"
        :pedido-id="pedido.id"
        :logs="pedido.logs"
        @form:close="dialog_log_pedido = false"
      />
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from "axios";
import EventBus from "@/EventBus";
//import GmapCustomMarker from "vue2-gmap-custom-marker";
import FormChangeStatus from "@components/FormChangeStatus";
import FormDireccionAnonimo from "@components/FormDireccionAnonimo";
import LogPedido from "@components/LogPedido";

export default {
  name: "PedidosDetalle",
  components: {
    FormChangeStatus,
    LogPedido,
    FormDireccionAnonimo,
    /*  GmapCustomMarker, */
  },
  props: {
    pedidoId: {
      type: [Number, String],
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Cantidad",
          value: "cantidad",
        },
        {
          text: "Nombre",
          value: "producto.nombre",
        },
        {
          text: "Precio",
          value: "precio",
        },
        {
          text: "Importe",
          value: "importe",
        },
      ],

      headersModificadores: [
        {
          text: "Cantidad",
          value: "cantidad",
        },
        {
          text: "Nombre",
          value: "producto.nombre",
        },
        {
          text: "Precio",
          value: "precio",
        },
        {
          text: "Importe Modificadores",
          value: "importeModificadores",
        },
        {
          text: "Importe",
          value: "importe",
        },
      ],
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },

      pedido: null,
      estatus: null,
      pedido_detalles: [],
      cliente: null,
      anonimo: null,
      direccion: null,
      tab_log_pedido: null,
      loading_estatus: false,
      loading_pedido: false,
      dialog_change_status: false,
      dialog_see_delivery_log: false,
      dialog_change_direccion: false,
      dialog_log_pedido: false,
      error_comentario: "",
      loadingAclaracion: false,
      aclaracion: {
        comentario: "",
      },
    };
  },
  computed: {
    tieneModificadores() {
      let result = false;
      this.pedido_detalles.forEach((element) => {
        if (element.modificador_detalles.length) {
          result = true;
        }
      });
      return result;
    },
    estatus_list() {
      return [].concat(this.$root.estatus_all);
    },
    pagosPedido() {
      if (this.pedido && this.pedido.pagos.length) {
        return this.pedido.pagos;
      }
      return [];
    },
    logs() {
      let logs = [];
      if (this.pedido && this.pedido.delivery_queue) {
        let queue_logs = this.pedido.delivery_queue.delivery_queue_logs;
        let delivery_queue_log = this.pedido.delivery_queue.log;

        queue_logs = queue_logs.map((item) => {
          item.usuario_email = item.usuario.email;
          return item;
        });

        if (Object.keys(delivery_queue_log).length) {
          Object.keys(delivery_queue_log).map(function (key) {
            let element = delivery_queue_log[key];
            let queue = queue_logs.find(
              (item) => item.usuario_email === element.id
            );
            let vendedor = Object.assign(element, {
              queue: queue,
              infoText: element.id,
            });

            if (queue) {
              switch (queue.status) {
                case "accepted":
                  vendedor.status = "Aceptada";
                  break;
                case "rejected":
                  vendedor.status = "Rechazada";
                  break;
                case "sent":
                  vendedor.status = "Enviada";
                  break;
                default:
                  vendedor.status = "N/A";
              }
            }

            logs.push(element);
          });
        }
        return logs;
      } else {
        return [];
      }
    },
    direccion_mapa() {
      if (this.pedido.anonimo) {
        return this.pedido.anonimo_detalles.direccion;
      } else {
        return this.pedido.direccion;
      }
    },
    repartidor() {
      if (this.pedido.repartidor) {
        return this.pedido.repartidor;
      } else {
        return { email: false };
      }
    },
  },
  mounted() {
    this.cargarPedido();
  },
  methods: {
    agregarAclaracion() {
      this.error_comentario = "";
      if (!this.pedido.aclaracion.comentario) {
        this.error_comentario = "Debe de agregar un comentario";
        return;
      }
      const { id } = this.pedido.aclaracion;
      this.loadingAclaracion = true;
      axios
        .post(`/api/aclaracion/${id}/aclarar`, this.pedido.aclaracion)
        .then(({ data }) => {
          this.cargarPedido();
          this.$_showMessage(data.message);
        })
        .finally(() => {
          this.loadingAclaracion = false;
        });
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = {
        lat: marker.position.latitude,
        lng: marker.position.longitude,
      };
      this.infoOptions.content = marker.infoText;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }

      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    cargarPedido() {
      axios
        .get("/api/pedidos/ver/" + parseInt(this.pedidoId))
        .then((responseOk) => {
          //let {data} = responseOk;

          let {
            data: { data: pedido },
          } = responseOk;

          this.pedido = pedido;
          this.anonimo = pedido.anonimo ? pedido.anonimo_detalles : null;
          this.cliente = pedido.user;
          this.direccion = pedido.anonimo
            ? this.anonimo.direccion
            : pedido.direccion;
          this.estatus = pedido.estatus;
          this.pedido_detalles = pedido.pedido_detalles;
        });
    },
    estatusCambiado(data) {
      this.dialog_change_status = false;
      this.pedido = Object.assign(this.pedido, data.data);
      this.estatus = Object.assign(data.data.estatus);
    },
    listarStatus() {
      // console.log("PedidoDetalle::status")
      // this.loading_estatus = true;
      // axios.get('/api/pedidos/listar-estatus')
      //     .then(({data}) => {
      //         const fill = this.estatus_list.concat(data.data);
      //         this.estatus_list = Object.assign(fill);
      //         this.loading_estatus = false;
      //     });
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    noPuedeEditarDireccion() {
      EventBus.$emit("tugarrafon:show-snackbar", {
        text_content:
          "Puedes editar la dirección desde el catálogo de clientes",
        color: "warning",
      });
    },
  },
};
</script>

<style scoped>
</style>
